<template>
    <v-card
        width="200px"
    >
        <v-card-title v-if="treeData.name != 'root'">
            <div v-if="!!treeData.keyWords || !!treeData.anyWord">Слова: {{(treeData.anyWord > 0) ? "Любое слово" : treeData.keyWords.replace(/\|/g, ", ") }}</div>
            <div v-else>Цифра: {{(treeData.digit=="") ? "Отсаваться на линии" : treeData.digit}}</div>
            <div v-if="!!treeData.record">
                <div v-if="!!treeData.record.id && savedAudio">Запись: {{ savedAudio.find(element => element.id == treeData.record.id).name }}</div>
                <div v-if="!!treeData.record.text">Текст: {{ truncateString(treeData.record.text, 10) }}</div>
            </div>
            <v-dialog
                v-model="dialog"
                persistent
                width="500"
                >
                <template v-slot:activator="{ on }">
                    <v-btn
                    color="red lighten-2"
                    v-on="on"
                    >
                    Редактировать
                    </v-btn>
                </template>
                <v-card>
                    <v-card-text>
                        
                        <v-row>
                            <v-col cols="12">
                                <ivrRecognition :element="treeData"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <audioSelector :element="treeData" type="record"/>
                            </v-col>
                            <v-col cols="12">
                                <webHook :element="treeData"/>
                            </v-col>
                            <v-col cols="12">
                                <ivrRepeat :element="treeData"/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="green" @click="closeDialog()">Сохранить</v-btn>
                        <v-btn color="red" @click="removeElement()">Удалить</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-card-actions>
            <v-btn 
                icon
                small
                v-if="treeData.ivrs.length != 0 && treeData.name != 'root'"
                @click="toggleExtend()"
            >
                <v-icon v-if="!treeData.extend">mdi-chevron-down</v-icon>
                <v-icon v-else>mdi-chevron-up</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                v-if="treeData.hasOwnProperty('record')"
                icon
                small
                @click="addElement()"
                color="green"
            >
            <v-icon >mdi-plus</v-icon>
            </v-btn>
            <v-btn
                v-if="treeData.name != 'root'" 
                icon
                small
                @click="removeElement()"
                color="red"
            >
            <v-icon >mdi-minus</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import audioSelector from "./audioSelector";
import ivrRepeat from "./ivrRepeat";
import ivrRecognition from "./ivrRecognition";
import webHook from "./webHook";
export default {
    name: "TreeElement",
    components: {
        audioSelector,
        ivrRepeat,
        ivrRecognition,
        webHook,
    },
    props: ["json"],
    data() {
        return {
            treeData: {},
            dialog: false,
        }
    },
    created() {
        if (this.treeData.name == 'new') {
            this.dialog = true;
            delete this.treeData.name;
            this.treeData.ivrs.push();
        }
    },
    computed: {
        savedAudio() {
            return this.$store.getters.RECORDS;
        }
    },
    watch: {
        json: {
            handler: function(Props){
                if (Props) {
                    this.treeData = Props;
                }
            },
            immediate: true
        },
        treeData: {
            handler: function(Props) {
                if (Props.ivrs.length != 0) {
                    if (Props.ivrs[0].hasOwnProperty('keyWords') || Props.ivrs[0].hasOwnProperty('anyWord')) {
                        Props.recognize = 1
                    } else if (Props.recognize == 1) {
                        delete Props.recognize
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        toggleExtend() {
            this.$emit('click-extend', this.treeData);
            this.$forceUpdate();
        },
        addElement() {
            this.treeData.ivrs.push({
                name: 'new',
                ivrs: [],
            })
        },
        removeElement() {
            this.$emit('click-delete', this.treeData);
        },
        validate() {
            var valid = true;
            if (this.treeData.hasOwnProperty('record')) {
                if (this.treeData.record.id == '' || this.treeData.record.text == "") {
                    valid = false
                }
            }
            //TODO валидация
            return valid
        },
        closeDialog() {
            if (this.validate()) {
                this.dialog = false;
            } else {
                this.$toaster.error('Ошибка!');
            }
        },
        truncateString(str, num) {
            if (str.length <= num) {
                return str
            }
            return str.slice(0, num) + '...'
        }
    }
}
</script>

<style>

</style>